import CategoryBar from './CategoryBar.jsx';

export default CategoryBar;


// WEBPACK FOOTER //
// ./src/components/CategoryBar/index.jsx